'use strict';

/**
 *
 * @name: seriesGroupExtended
 *
 */

import DirectiveTemplate from './nn-seasons-group-extended.directive.html';
import './nn-seasons-group-extended.directive.scss';

function SeasonsGroupExtendedDirective(
  $rootScope,
  $timeout,
  $document,
  apiSeasonsService,
  transObject,
  seasonsAnalytics,
  $q
) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    transclude: true,
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    link: function(scope, element) {

      /**
       *
       * @CONFIG
       *
       */

      scope.item = scope.content();
      scope.item.title = scope.item.title || 'SEASONS';
      scope.analytics = seasonsAnalytics;

      /**
       *
       * @PUBLIC
       *
       */

      scope.onAnalyticsClick = post => {
        $rootScope.analytics.videoAM('single series', scope.item.title, post)
      }

      scope.videoUrl = (openedPost, post) => {
        return '/seasons/' + openedPost.translations[$rootScope.lang].slug + '/' + post.translations[$rootScope.lang].slug
      }

      scope.fetchSeason = singleSeason => {

        var deferred = $q.defer();

        apiSeasonsService
          .getSeasonsById(singleSeason.id, true)
          .then(res => {

            res.data.posts.forEach(function(item) {

              transObject.translate(item);
              transObject.getDuration(item);
              transObject.setBookmark(item);
              transObject.calendarDate(item);
              transObject.trueSlug(item);
            });

            deferred.resolve(res.data.posts);
          });

        return deferred.promise;
      }


      /**
       *
       * @PRIVATE
       *
       */

      function terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      function init() {

        if (!scope.item.jsonData.sources || !scope.item.jsonData.sources.length) {
          return terminate();
        }
        scope.item.jsonData.sources.forEach(function(source) {
          scope.item.seasons.some(function(series) {
            if (series.id === source.seasonId) {
              source = series;
            }
          })
        });

        scope.item.seasons.forEach(function(serie) {
          if (scope.item.jsonData.sources.length > 1) {
            scope.item.jsonData.sources.some(function(item, index) {
              if (serie.id === item.seasonId) {
                serie.index = index;
                return true;
              }
              return false;
            });
          }
          transObject.translate(serie);
        });

        scope.loaded = true;

      }

      /**
       *
       * @INIT
       *
       */

      init();

    }
  };
}

export default SeasonsGroupExtendedDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/seasons/nn-seasons-group-extended/nn-seasons-group-extended.directive.js